/**
 * Shared run guardrails for the Item Prize Automator, referenced by both the Generate panel (as
 * form-field max validators) and the Filters drawer (as static reference text) — single source
 * so the two surfaces can never drift out of sync with each other.
 */
export const MAX_GENERATE_DAYS = 15;
export const MAX_PRIZES_PER_DAY = 10;
/** Independent caps per pool (CMS-6210) — a category's Daily Prize Weights pick does not count against its Remaining Prize Weights cap, and vice versa. */
export const MAX_OCCURRENCES_PER_CATEGORY_IN_DAILY_POOL = 2;
export const MAX_OCCURRENCES_PER_CATEGORY_IN_REMAINING_POOL = 2;
